<template>
  <!-- <div class="sidebar-footer"></div> -->
  <span class="d-none"></span>
</template>
<script>

export default {
  name: 'sidebar-footer'
}
</script>
